import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';
import { DraftPetition } from '../../../../../../../shared/admin-models/interfaces/draft-Petition.iterface';
import { Petition } from '../../../../../../../shared/admin-models/interfaces/petition.interface';
import { Response } from '../../../../../../../shared/admin-models/classes/response.class';

@Component({
  selector: 'app-defect-dialog',
  templateUrl: './defect-dialog.component.html',
  styleUrls: ['./defect-dialog.component.scss']
})
export class DefectDialogComponent implements OnInit {
  file: File;
  comment: string = '';
  draftPetition: DraftPetition;
  fileId: string;
  fileUploadProgress: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DefectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public petition: Petition,
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getdrafts();
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  getdrafts(): void {
    this._loadingService.register();
    const data = {
      petitionId: this.petition.id,
      currentStatusId: this.petition.statusId,
      type: 1
    };
    this._adminService
      .findDrafts(data)
      .subscribe((res: Response<DraftPetition[]>) => {
        this._loadingService.resolve();
        if (
          res &&
          res.result &&
          res.result &&
          res.result.data &&
          res.result.data.length
        ) {
          this.draftPetition = res.result.data.find(
            (element) =>
              element.currentStatusId === this.petition.statusId &&
              element.type === 1
          );
          this.fileId = this.draftPetition.fileId;
          this.comment = res.result.data[0].commentary;
        } else {
        }
      },
      (err) => {
        this._snackBar.open('დაფიქსირდა შეცდომა',null,{
          duration:2000,
          panelClass:'red-snackbar',
          horizontalPosition:"right",
          verticalPosition:"top"
        })
      });
  }
  uploadFile(e): void {
    this.fileUploadProgress = true;
    this.file = e.target.files[0];
    const fileReqData = new FormData();
    fileReqData.append('file', this.file);
    this._adminService.uploadFile(fileReqData).subscribe((res) => {
      this.fileUploadProgress = false;
      this.fileId = res._id;
    },
    (err) => {
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    });
  }
  saveDraft() {
    this._loadingService.register();
    const data: DraftPetition = {
      id: this.draftPetition ? this.draftPetition.id : null,
      petitionId: this.petition ? this.petition.id : null,
      commentary: this.comment ? this.comment : null,
      fileId: this.fileId ? this.fileId : null,
      currentStatusId: this.petition.statusId,
      type: 1
    };
    this._adminService.saveDratf(data).subscribe((res) => {
      this._loadingService.resolve();
      this.dialogRef.close('შაბლონი წარმატებით დამახსოვრდა');
    },
    (err) => {
      this._loadingService.resolve();
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    });
  }
  sendDefect() {
    this._loadingService.register();
    const data = {
      commentary: this.comment && this.comment.length ? this.comment : null,
      fileId: this.fileId ? this.fileId : null
    };
    this._adminService
      .changePetitionStatusToDefect(data, this.petition.id)
      .subscribe((res) => {
        (res);
        this._loadingService.resolve();
        this.dialogRef.close('სტატუსი წარმატებით შეიცვალა')
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა',null,{
          duration:2000,
          panelClass:'red-snackbar',
          horizontalPosition:"right",
          verticalPosition:"top"
        })
      });
  }
  openFile(): void {
    this._adminService.openFilePdf(this.fileId);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/defect-dialog/defect-dialog.component.ts